export default function truncateAndEllipsis(str: string, chars: number = 45): string {
  if (str.length > chars) {
    return `${str.substring(0, 30)}...`;
  }
  return str;
}
